"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Backend = require('i18next-http-backend');
const i18next = require('i18next');
const react_i18next_1 = require("react-i18next");
const i18nInstanceCreator = () => {
    return i18next.use(Backend).use(react_i18next_1.initReactI18next);
};
exports.default = i18nInstanceCreator;
